export default function gte(first: number, second: number) {
  return first >= second;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    gte: typeof gte;
  }
}
